import { CoordinatorService } from './coordinator.service';
import { ScriptHitset } from './script-hitset';
import { SCRIPT_TYPE } from './script-types';

export class ScriptOverlap {
    #coords: CoordinatorService;
    private _inOrigin?: ScriptHitset;
    private _inTarget?: ScriptHitset;
    private _inBoth?: ScriptHitset;

    constructor(
        coords: CoordinatorService,
        private _origin: ScriptHitset,
        private _target: ScriptHitset,
        public isPreview = false,
    ) {
        this.#coords = coords;
    }

    field(type: 'size' | 'overlap' | 'only' | 'missing', hs: ScriptHitset) {
        if (!hs || this._inBoth === undefined) return;
        let h: ScriptHitset;
        let isCheckSize = false;

        const payload: any = { title: hs.title };
        switch (type) {
            case 'size':
                h = hs;
                isCheckSize = true;
                payload.icon = 'overlap_size';

                break;
            case 'overlap':
                h = this._inBoth!.clone();
                payload.icon = 'overlap';

                break;
            case 'only':
                h = (hs === this._origin! ? this._inOrigin : this._inTarget)!.clone();
                payload.icon = 'overlap_only';
                break;
            case 'missing':
                h = (hs === this._origin! ? this._inTarget : this._inOrigin)!.clone();
                payload.icon = 'overlap_missing';
                break;
        }
        h.payload = payload;

        return h.field(`overlap_field_${type}`);
    }

    key(isReverse = false) {
        return isReverse
            ? `${this._target.id}_${this._origin.id}`
            : `${this._origin.id}_${this._target.id}`;
    }

    private _originTargetSets(inPreview = false) {
        let originIdSet = this._origin.idSet;
        let targetIdSet = this._target.idSet;

        if (this.origin.isPreview !== this.target.isPreview) {
            if (inPreview) {
                if (this.origin.isPreview)
                    targetIdSet = new Set(this.#coords.dataset$.fromMain2PreviewIdLs(targetIdSet));
                else originIdSet = new Set(this.#coords.dataset$.fromMain2PreviewIdLs(originIdSet));
            } else {
                if (this.origin.isPreview)
                    originIdSet = new Set(this.#coords.dataset$.fromPreview2MainIdLs(originIdSet));
                else targetIdSet = new Set(this.#coords.dataset$.fromPreview2MainIdLs(targetIdSet));
            }
        }

        return { originIdSet, targetIdSet };
    }

    calcDistribution() {
        for (const type of ['both', 'only', 'missing'] as const) {
            this._calc(type);
        }
    }

    private _calc(type: 'both' | 'only' | 'missing') {
        const s = new Set<string>();
        const { originIdSet, targetIdSet } = this._originTargetSets(
            (type === 'only' && this.origin.isPreview) ||
                (type === 'missing' && this.target.isPreview),
        );

        switch (type) {
            case 'both':
                this._inBoth = new ScriptHitset(
                    this.#coords,
                    this.origin.isPreview && this.target.isPreview,
                );
                originIdSet.forEach((x: string) => targetIdSet.has(x) && s.add(x));
                this._inBoth.idSet = s;
                break;
            case 'only':
                this._inOrigin = new ScriptHitset(this.#coords, this.origin.isPreview);
                originIdSet.forEach((x: string) => !targetIdSet.has(x) && s.add(x));
                this._inOrigin.idSet = s;
                break;
            case 'missing':
                this._inTarget = new ScriptHitset(this.#coords, this.target.isPreview);
                targetIdSet.forEach((x: string) => !originIdSet.has(x) && s.add(x));
                this._inTarget.idSet = s;
        }
    }

    get both() {
        if (!this._inBoth) this._calc('both');
        return this._inBoth!;
    }

    get only() {
        if (!this._inOrigin) this._calc('only');
        return this._inOrigin!;
    }
    get missing() {
        if (!this._inTarget) this._calc('missing');
        return this._inTarget!;
    }

    get origin() {
        return this._origin;
    }

    get target() {
        return this._target;
    }

    display() {
        return this;
    }

    log(prefix = 'Overlap') {
        console.log(
            `${prefix}: Origin: ${this._origin.title}, Target: ${this._target.title}, Both: ${this.both.size}, Only: ${this.only.size}, Missing: ${this.missing.size} `,
        );
        return this;
    }
}
